module.exports = __webpack_public_path__ + "static/media/avatars_female_7.17540e76.png";